import React from 'react'
import Wrapper from '../../../components/common/Wrapper/Wrapper'
import molecules from '../../../components/molecules';
import organisms from '../../../components/organisms';
const { TopBar } = molecules
const { StoreRequested } = organisms

const Index = () => {
  return (
    <Wrapper>
      <div className='row align-items-center'>
        <TopBar heading='For Store Requested' />
      </div>
      <div className='row mt-4'>
        <StoreRequested />
      </div>
    </Wrapper>
  )
}

export default Index